<template>
  <tm-icon
    class="dropdown-direction"
    :class="[
      'dropdown-direction',
      {
        'dropdown-direction--opened': opened,
      },
    ]"
    :name="name"
    :size="size"
    :color="color"
  />
</template>

<script setup lang="ts">
import TmIcon from '@/components/shared/TmIcon.vue'
import type { IconName } from '@/assets/icons/icons'
import type { IconSize } from '@/components/shared/types'
import type { StyleColors } from '@/constants/styleColors'

defineProps<{
  name: IconName
  size?: IconSize
  color?: StyleColors
  opened?: boolean
}>()
</script>

<style lang="scss" scoped>
.dropdown-direction {
  transition-property: transform;
  transition-duration: var(--dropdown-direction-transition-duration, $transition-duration-300ms);
  transition-timing-function: $transition-function-ease-in-out;

  &--opened {
    transform: rotate(180deg);
  }
}
</style>
